const compareUvVisJcamp = `
##TITLE=HPLC_ML-579
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=HPLC_ML-579
##JCAMP-DX=5.00
##DATA TYPE=HPLC UV/VIS SPECTRUM
##DATA CLASS=XYDATA
##$CSCATEGORY=SPECTRUM
##ORIGIN=
##OWNER=
##XUNITS=MINUTES
##YUNITS=TRANSMITTANCE
##XFACTOR=1.0
##YFACTOR=0.00040120989100000005
##FIRSTX=30.0
##LASTX=0.003333
##MAXX=30.0
##MAXY=401.209891
##MINX=0.003333
##MINY=-1.308345454551
##NPOINTS=9000
##XYDATA= (X++(Y..Y))
9000c039c023c009b997b990b987b986b984b980b975b969b962b955b949b942b935b927
8983b920b914b908b904b897b889b882b875b868b859b849b840b835b834b836b837b839
8966b839b841b844b849b853b856b855b852b848b842b836b830b826b823b821b820b822
8949b823b824b823b819b813b808b802b798b795b792b789b789b786b784b781b776b767
8932b758b745b734b724b717b711b705b702b700b700b700b698b695b694b693b694b698
8915b705b714b719b724b723b722b718b718b716b716b717b718b721b723b723b718b712
8898b704b696b695b695b699b701b702b703b703b703b702b700b699b698b701b706
8882b711b713b711b703b694b685b679b674b674b677b681b685b688b688b688b690
8866b695b706b717b727b735b742b749b756b761b764b765b765b765b765b767b771
8850b774b777b781b785b790b799b808b818b828b837b848b858b868b875b880b882
8834b879b872b865b859b856b858b866b876b886b895b900b903b905b905b906b910
8818b914b919b924b929b934b941b950b959b968b975b981b986b991b996c002c010
8802c019c030c044c062c081c101c118c131c140c147c153c159c166c176c186c196
8786c202c207c210c213c219c224c232c239c245c249c250c251c251c252c253c255
8770c257c259c260c260c257c253c247c242c237c235c233c233c232c230c226c221
8754c216c212c210c208c206c202c197c190c185c180c176c172c166c162c159c160
8738c164c166c165c158c146c129c108c084c060c041c025c016c008b999b988b976
8722b965b954b947b939b930b919b907b895b883b873b863b853b843b832b818b804
8706b789b779b770b765b764b765b769b775b781b785b788b788b785b782b779b778
8690b777b775b772b769b765b762b760b761b763b765b766b769b767b766b764b760
8674b760b763b770b778b785b787b785b777b764b749b734b719b709b700b694b690
8658b688b687b687b687b686b686b687b689b690b689b686b682b677b672b670b667
8642b666b667b669b671b671b672b675b678b683b690b699b711b725b739b752b763
8626b772b779b786b793b799b805b811b818b824b829b833b836b842b849b857b866
8610b875b881b886b889b892b895b901b906b912b920b928b936b942b944b947b950
8594b954b962b969b976b983b988b994b999c002c008c012c018c023c028c032c035
8578c038c040c040c039c039c042c048c059c069c077c082c080c072c057c039c021
8562c008c001b997b994b992b989b987b983b978b974b967b959b950b939b928b919
8546b911b904b899b893b884b875b864b853b843b836b832b830b830b830b829b827
8530b826b825b825b827b829b830b828b824b820b814b810b806b802b800b796b793
8514b789b789b789b789b792b795b797b798b799b801b805b811b814b816b812b803
8498b789b775b759b746b737b733b735b738b740b739b734b729b724b718b715b711
8482b709b709b710b711b711b710b706b701b695b690b685b682b680b679b680b684
8466b690b699b708b715b718b716b713b710b708b708b707b707b707b706b706b705
8450b705b705b706b708b711b713b715b716b717b718b719b722b726b729b731b731
8434b731b730b727b725b722b721b723b729b737b746b755b763b767b771b771b770
8418b770b772b777b784b793b801b808b813b818b823b828b833b837b841b844b848
8402b851b853b853b848b840b831b823b818b814b813b813b812b812b811b811b810
8386b811b812b812b813b813b817b822b826b828b827b826b824b825b827b831b835
8370b840b844b849b855b863b875b889b904b915b921b924b928b933b941b950b959
8354b969b980b992c002c013c022c030c037c044c052c061c072c083c094c105c113
8338c120c130c142c155c166c172c173c166c159c152c147c143c142c141c142c146
8322c153c160c166c171c173c175c178c180c180c178c173c167c164c161c161c162
8306c163c162c161c159c157c155c153c154c156c160c165c170c172c174c174c175
8290c175c175c173c171c167c164c161c157c153c151c151c150c149c147c143c142
8274c140c140c142c142c143c142c138c133c129c126c124c124c124c125c126c126
8258c126c124c123c122c120c119c118c117c116c114c111c109c107c108c110c113
8242c114c115c115c115c115c116c118c118c116c111c104c095c083c071c058c047
8226c038c032c026c024c022c021c021c018c014c008c001b995b990b988b988b989
8210b987b983b978b975b973b971b969b968b967b967b967b969b973b978b987b999
8194c012c024c036c043c047c049c054c057c060c062c064c067c072c079c085c091
8178c094c095c099c104c112c120c132c142c154c163c169c171c171c169c165c160
8162c154c150c148c148c149c150c151c152c153c155c158c159c158c154c148c142
8146c137c134c133c131c130c127c122c116c107c095c086c075c066c059c055c053
8130c054c055c056c055c051c048c045c041c036c028c017c006b997b988b980b972
8114b964b955b947b937b927b918b907b900b891b882b872b863b856b852b851b851
8098b851b851b849b843b835b826b816b808b802b799b797b794b790b785b778b771
8082b764b759b757b757b759b761b763b762b761b759b759b761b763b764b765b765
8066b760b751b736b718b698b682b671b667b669b671b672b671b670b667b665b662
8050b659b655b648b643b639b639b644b649b655b659b659b656b652b648b649b653
8034b658b662b667b672b680b687b694b698b701b704b707b710b716b723b730b738
8018b746b755b763b771b777b783b788b792b796b800b803b808b813b822b831b840
8002b847b852b854b853b849b844b839b836b836b839b841b841b837b834b830b825
7986b820b813b810b808b806b805b802b797b793b789b786b783b779b773b765b757
7970b748b738b727b718b713b712b712b711b709b705b702b700b699b700b700b699
7954b694b687b678b669b659b649b643b639b637b636b634b631b627b620b610b601
7938b593b587b583b582b585b589b593b597b599b600b599b596b593b587b582b577
7922b574b574b576b578b582b583b583b582b582b584b589b594b600b604b607b611
7906b616b623b630b636b641b643b646b646b644b639b630b620b610b602b600b601
7890b606b611b615b616b617b617b617b617b617b619b623b628b632b636b637b638
7874b640b643b647b652b658b664b669b671b674b677b683b693b707b722b737b749
7858b758b765b772b778b786b793b801b810b818b824b827b828b832b839b848b857
7842b864b868b871b873b875b878b883b892b902b912b917b918b915b908b900b890
7826b883b879b879b881b882b882b881b881b880b879b878b875b872b868b864b860
7810b860b858b855b849b841b835b829b826b823b821b819b818b817b817b818b821
7794b825b827b828b829b828b826b824b824b825b826b824b821b818b819b823b826
7778b829b830b830b830b831b835b840b846b853b860b866b871b874b878b881b884
7762b889b895b902b908b914b919b924b929b936b943b949b954b959b962b965b968
7746b971b976b982b988b993b998c001c006c013c019c024c030c034c037c040c040
7730c036c029c018c007b997b990b985b982b981b981b981b982b981b977b974b971
7714b969b970b972b973b972b969b967b966b968b972b976b977b977b975b974b975
7698b978b986b996c008c020c032c043c051c058c063c068c075c084c094c103c112
7682c119c125c131c134c135c137c142c150c160c170c180c189c199c206c212c217
7666c224c230c236c237c237c235c231c226c221c216c213c213c214c217c220c224
7650c229c233c235c235c232c226c219c213c207c202c198c193c188c183c176c167
7634c159c151c142c137c135c138c146c155c164c170c170c167c162c155c147c137
7618c128c119c112c103c093c085c079c075c071c066c059c049c039c028c017c006
7602b997b990b985b982b978b977b974b971b967b962b954b943b933b923b914b907
7586b901b896b890b883b873b861b852b843b835b829b823b817b811b805b801b800
7570b801b802b802b800b795b789b782b772b759b743b728b713b698b687b679b674
7554b669b663b657b652b647b643b640b639b639b637b633b628b622b618b615b614
7538b612b607b602b601b601b602b608b614b621b631b641b649b659b666b671b678
7522b683b688b692b695b696b699b701b705b712b719b729b738b745b751b756b761
7506b770b780b789b797b802b806b809b811b813b816b816b813b805b796b788b781
7490b776b771b765b762b761b761b762b761b759b756b752b749b747b748b750b750
7474b749b743b737b730b724b717b711b706b702b701b702b703b704b704b705b706
7458b705b704b701b696b691b684b677b669b663b659b655b651b647b644b640b636
7442b632b628b624b619b614b610b606b601b597b593b591b591b591b591b591b591
7426b589b587b583b577b574b568b563b558b554b552b551b550b550b552b555b560
7410b564b567b569b572b576b580b583b585b584b583b583b584b586b587b585b578
7394b568b554b541b530b524b523b523b524b523b521b519b516b515b513b511b508
7378b505b502b498b494b490b488b488b491b497b502b504b504b501b498b497b499
7362b504b514b528b544b555b563b568b572b577b586b594b601b606b609b610b612
7346b616b623b632b639b642b643b642b642b643b647b651b655b658b660b662b665
7330b668b671b671b672b672b671b671b669b668b669b672b678b685b690b692b692
7314b691b688b687b687b688b689b688b687b687b688b689b691b692b694b696b700
7298b699b694b686b675b661b646b631b620b612b609b606b602b600b596b590b583
7282b577b572b567b562b557b552b547b541b533b526b521b518b515b511b507b502
7266b496b488b481b476b472b472b474b479b484b488b489b489b489b489b490b489
7250b487b483b480b477b475b475b476b477b477b477b478b480b483b485b486b486
7234b486b488b492b497b501b502b498b486b470b453b440b430b423b417b412b408
7218b404b401b399b398b397b397b396b396b395b395b396b399b403b404b404b400
7202b395b390b385b383b382b384b388b393b401b411b422b431b438b444b450b455
7186b460b463b464b464b464b467b472b479b484b487b489b489b491b493b495b497
7170b499b500b500b500b499b499b501b503b505b507b510b512b513b513b511b510
7154b507b507b505b503b501b498b494b491b487b484b483b484b486b489b492b495
7138b495b495b494b493b492b490b487b484b480b473b464b453b441b430b420b412
7122b407b402b397b391b384b377b369b363b357b352b349b344b339b333b328b324
7106b321b319b318b315b312b310b307b303b299b292b284b277b271b267b266b266
7090b268b272b275b277b277b274b272b270b268b265b260b256b252b250b250b250
7074b248b245b240b235b230b228b228b229b231b233b234b234b233b232b232b232
7058b233b236b242b248b254b260b263b265b268b272b278b285b291b297b302b306
7042b312b318b325b334b347b362b378b394b410b424b437b450b459b464b466b463
7026b458b453b452b457b466b475b484b491b497b505b513b521b529b536b541b545
7010b548b553b560b569b578b587b595b601b605b604b601b596b593b594b600b611
6994b625b645b665b684b698b708b714b718b719b721b722b726b733b742b750b755
6978b757b758b761b765b773b780b786b792b797b804b813b824b836b848b856b860
6962b859b854b845b831b814b801b792b788b788b789b794b797b798b796b794b794
6946b794b795b795b797b799b803b806b807b805b802b797b789b783b776b770b765
6930b764b765b769b776b785b797b809b818b824b827b829b830b829b827b824b823
6914b823b823b825b826b827b829b831b836b842b847b850b850b848b848b850b856
6898b863b868b870b869b868b869b872b879b886b892b894b895b896b897b898b901
6882b905b911b918b925b930b938b946b955b966b977b986b995c002c011c020c030
6866c041c051c059c065c069c072c072c069c064c057c053c053c057c063c069c075
6850c078c079c078c077c078c082c087c092c095c095c092c087c083c079c078c077
6834c076c075c071c065c056c048c042c041c044c052c061c069c073c075c071c066
6818c061c055c048c042c035c026c020c014c008c001b996b990b984b978b976b973
6802b971b968b964b959b954b947b939b928b914b893b868b842b818b799b785b776
6786b769b762b753b742b728b713b699b688b677b668b658b648b637b629b622b616
6770b610b601b590b576b562b548b538b533b530b530b530b530b530b530b530b529
6754b525b520b514b507b504b501b500b500b497b492b485b478b472b468b468b469
6738b470b469b467b465b462b459b455b451b449b450b453b459b467b473b478b479
6722b478b477b475b475b477b481b489b498b507b518b525b530b533b538b544b552
6706b561b572b586b601b616b629b641b652b664b677b690b700b707b711b711b708
6690b705b704b704b707b712b718b727b737b747b754b759b761b764b769b776b787
6674b800b812b820b826b830b833b836b840b844b849b854b857b860b866b874b884
6658b895b904b914b922b930b936b942b947b951b954b955b959b963b966b967b967
6642b968b970b974b978b985b990b995b999c005c010c015c020c025c031c034c034
6626c032c026c020c011c004b999b998b999c001c005c008c011c015c018c022c024
6610c025c028c031c035c037c037c036c034c034c036c039c041c043c043c043c044
6594c048c054c063c073c086c095c104c109c112c114c115c116c117c119c123c126
6578c126c126c124c123c122c119c118c115c111c106c102c096c094c091c086c079
6562c070c061c053c046c040c033c025c020c015c010c004b997b989b980b969b958
6546b949b940b931b925b917b908b902b894b887b880b874b869b866b863b860b860
6530b860b860b856b848b835b819b803b789b778b769b761b753b745b739b734b730
6514b728b726b723b719b716b714b713b713b714b714b714b712b710b707b704b700
6498b698b698b702b709b718b729b740b750b759b767b777b786b794b801b809b817
6482b826b834b841b848b854b860b867b873b880b887b895b902b910b918b928b937
6466b944b950b955b964b973b982b987b985b977b968b957b948b944b942b942b943
6450b944b943b939b934b927b921b917b915b913b911b908b906b904b900b895b887
6434b878b869b860b852b845b837b832b828b825b825b826b826b826b822b813b803
6418b792b782b773b764b754b746b739b732b725b716b706b695b689b683b676b669
6402b661b652b644b637b632b628b624b620b614b607b600b593b586b577b570b563
6386b557b553b552b551b550b550b550b550b550b550b550b551b552b554b554b554
6370b553b552b551b552b554b558b563b569b574b578b582b581b577b570b562b553
6354b546b540b538b538b540b543b548b552b554b554b555b554b554b554b555b558
6338b560b562b561b559b555b554b553b553b554b558b563b571b584b601b620b641
6322b662b681b695b705b710b714b719b729b741b754b766b780b789b799b806b813
6306b823b832b841b849b857b867b880b896b912b929b943b954b959b961b959b954
6290b949b940b931b925b920b918b918b920b922b924b924b921b918b916b915b915
6274b915b915b915b913b910b906b902b899b896b892b886b878b868b859b853b850
6258b850b851b852b850b846b842b836b829b820b810b801b793b786b778b770b763
6242b759b756b753b748b739b730b721b712b703b692b683b676b672b671b671b669
6226b666b660b653b644b635b629b624b622b620b618b614b610b608b606b605b604
6210b601b600b597b593b589b587b584b580b573b566b561b557b555b554b554b553
6194b550b549b550b550b548b544b538b534b530b529b529b528b526b522b518b515
6178b515b516b518b521b524b527b530b530b531b533b533b534b536b539b542b544
6162b546b549b553b558b566b574b584b594b601b609b613b619b624b630b632b632
6146b630b629b630b635b642b649b658b664b669b671b677b684b693b703b713b721
6130b729b735b739b741b740b736b731b726b723b718b717b714b713b711b711b713
6114b716b719b721b719b718b716b713b710b706b705b705b704b702b698b692b685
6098b680b678b677b675b671b666b663b662b664b668b674b678b680b680b682b685
6082b691b695b698b698b694b688b681b676b674b675b678b680b679b677b674b671
6066b671b672b672b672b674b676b678b679b679b678b678b680b681b681b678b675
6050b672b674b675b675b672b672b672b674b675b677b681b685b689b694b698b701
6034b702b703b704b706b708b711b713b713b711b706b698b688b674b660b647b638
6018b634b631b629b625b622b618b616b616b617b619b620b621b621b620b619b615
6002b611b606b601b595b590b586b585b585b587b591b597b605b615b625b637b648
5986b660b670b680b689b698b706b714b722b727b731b735b741b749b759b769b779
5970b788b796b802b809b816b824b834b844b855b867b877b884b888b887b881b872
5954b860b851b844b841b840b840b840b837b837b841b844b848b849b848b845b842
5938b837b832b824b814b807b801b797b792b784b773b760b745b733b725b719b718
5922b721b724b728b731b730b726b717b706b695b688b683b677b669b661b651b643
5906b635b628b621b613b602b593b582b573b566b559b553b545b536b527b520b516
5890b511b507b503b500b498b494b491b489b486b484b481b478b472b465b458b451
5874b447b444b442b443b446b450b453b455b454b453b450b446b443b442b443b443
5858b440b432b423b412b400b390b383b378b374b373b374b376b379b383b387b389
5842b391b391b391b390b390b391b392b391b388b384b379b375b374b374b374b374
5826b374b375b377b382b392b406b421b435b447b456b463b468b473b477b481b484
5810b486b487b490b495b502b508b516b523b529b536b544b552b558b563b565b565
5794b565b566b566b565b563b560b554b549b542b537b534b530b528b524b519b514
5778b508b503b498b492b487b482b477b471b464b456b446b437b428b419b411b404
5762b399b395b390b382b374b366b361b358b356b355b352b347b339b331b322b313
5746b302b289b276b264b255b248b243b238b234b231b228b225b220b214b207b201
5730b196b192b188b184b181b179b177b176b174b172b170b168b165b161b156b152
5714b149b146b143b141b137b134b131b130b128b127b126b126b129b134b140b146
5698b151b155b156b156b155b153b150b146b140b134b126b117b108b100b095b093
5682b092b092b091b090b089b089b090b091b093b095b096b096b095b093b093b095
5666b099b103b108b113b118b122b126b130b136b146b161b177b194b211b229b246
5650b265b283b300b316b329b342b356b372b390b410b429b447b462b476b492b508
5634b527b547b566b583b600b616b630b643b654b664b671b679b684b687b688b687
5618b684b682b680b681b682b685b687b690b693b695b696b699b702b703b705b707
5602b710b712b715b717b718b718b718b716b712b708b706b708b716b726b737b748
5586b759b769b777b782b784b783b780b778b777b778b781b785b790b796b801b807
5570b813b818b821b822b822b823b825b830b837b847b855b861b867b872b875b878
5554b880b883b887b893b898b902b905b907b910b913b915b918b921b924b927b929
5538b931b936b939b942b945b949b954b959b963b968b974b982b991b999c004c005
5522c001b996b989b982b975b970b967b965b964b964b967b971b977b983b986b986
5506b985b986b989b993b997b999b999b998b997b999c004c011c019c024c028c030
5490c034c042c055c069c083c095c103c108c111c114c118c124c130c137c143c151
5474c157c163c170c177c182c186c189c192c196c201c207c214c222c226c229c230
5458c231c231c232c232c228c221c213c208c204c200c197c190c185c178c171c165
5442c159c152c143c135c126c116c108c101c095c087c077c064c049c034c018c002
5426b988b974b960b946b934b924b915b906b894b881b867b853b840b826b810b790
5410b769b746b723b702b684b668b652b634b614b592b570b550b533b517b500b479
5394b456b432b411b391b373b356b340b324b307b291b275b262b249b234b218b201
5378b183b165b147b128b109b093b078b065b053b041b028b016b005a995a988a979
5362a970a959a947a935a923a912a902a889a872a850a825a801a779a761a744a727
5346a711a697a683a672a661a650a636a618a601a583a569a556a543a527a509a490
5330a470a451a435a420a404a388a371a355a340a327a316a306a296a285a273a258
5314a242a227a212a195a175a153a129a104a079a055a031a008i87i65i42i17h91
5297h64h38h17g95g73g51g26f99f65f26e84e38d92d45d03c61c19b77b33a89a44
5276i6d8@E2A06A61B19B80C42D08D77E49F24G01G82H66I55A045A137A232A329A430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@ga5b4c3d1e0f1g2h4i8a12a26a39a50
461a59a69a81a94b06b17b28b39b50b61b72b83b94c06c20c36c53c72c89d06d18
440d28d36d45d55d63d71d79d89e01e14e26e38e49e58e66e74e84e95f05f13f20
419f26f35f44f53f62f69f75f79f85f90f96g03g12g20g26g32g37g41g44g47g50
398g54g60g66g72g75g78g82g88g94g98h00h01h03h06h07h06h06h04h04h04h04
377h03h01g99g99h01h05h08h10h10h06h00g96g94g96h00h04h06h06h05h04h03
356h03h03h03h03h03h03h02h00g97g96g97g98g98g97g95g94g94g96h00h02h03
335h03h03h02h01g99g97g95g93g91g93g94g95g91g88g84g81g81g82g84g88g91
314g95g96g94g91g87g84g81g79g77g76g76g78g79g81g82g85g90g95h00h02h01
293h00g98g96g96g98h02h05h07h06h04h02h01h03h06h08h08h04g99g95g94g96
272g99h03h05h05h04h01g98g95g93g91g89g87g85g85g85g83g78g72g65g60g60
251g63g68g72g76g79g83g85g87g85g83g82g82g83g82g79g73g70g67g66g67g67
230g66g66g65g62g57g53g50g46g43g38g34g31g30g31g32g35g37g37g36g34g29
209g24g18g14g13g13g14g15g15g14g11g06g00f95f91f90f90f89f87f85f85f82
188f78f73f69f64f58f53f47f42f37f32f30f29f28f26f26f26f26f26f25f20f13
167f05e96e88e83e82e83e85e87e87e85e80e74e69e65e62e60e57e53e50e49e50
146e52e55e56e54e49e42e36e31e26e21e17e13e10e06e02d98d95d95d97d98d98
125d95d92d89d85d80d75d71d67d64d62d58d53d48d44d41d38d33d26d20d16d14
104d14d14d14d13d12d10d05c98c89c82c76c71c66c63c61c60c59c59c60c60c58
83c54c49c42c39c39c39c39c39c36c33c27c21c15c07c01b96b93b91b90b87b84
62b80b76b70b64b57b51b47b44b40b35b28b19b13b08b05b05b07b10b11b10b06
41b00a92a87a85a84a84a82a77a72a65a60a55a53a52a53a54a53a50a48a47a48
20a49a48a48a48a52a58a68a80a92a99b00a89a66a35i8f0c0a1b@
$$ === CHEMSPECTRA INTEGRALS AND MULTIPLETS ===
##$OBSERVEDINTEGRALS= (X Y Z)
(13.575614596938113, 14.70274982784308, 1.0)
(16.491463625265208, 18.01064420937241, 1.0035411022750662)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
$$ === CHEMSPECTRA SIMULATION ===
##$CSSIMULATIONPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=HPLC_ML-579
##JCAMP-DX=5.00
##DATA TYPE=UVVISPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=EDIT_PEAK
##$CSTHRESHOLD=0.05
##MAXX=30.0
##MAXY=401.209891
##MINX=0.003333
##MINY=-1.308345454551
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=2
##PEAKTABLE= (XY..XY)
14.05333315612846, 401.209891
16.98999985542838, 319.827331
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=HPLC_ML-579
##JCAMP-DX=5.00
##DATA TYPE=UVVISPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSCATEGORY=AUTO_PEAK
##$CSTHRESHOLD=0.05
##MAXX=30.0
##MAXY=401.209891
##MINX=0.003333
##MINY=-1.308345454551
##NPOINTS=2
##PEAKTABLE= (XY..XY)
14.05333315612846, 401.209891
16.98999985542838, 319.827331
##END=

##END=




`;

export default compareUvVisJcamp;
